/**
 * Portfolio Header Component
 * 
 * Displays the main header section for the portfolio page.
 * Contains:
 * - Main title introducing the portfolio section
 * - Descriptive subtitle explaining what products are showcased
 * 
 * @component
 * @returns {JSX.Element} Portfolio header with title and description
 */

import React from 'react';
import './portfolio-header-style.css';

const PortfolioHeader = () => {
  return (
    <div className="portfolio-header">
      <h1 className="portfolio-header__title">
        Galería de nuestros trabajos:
      </h1>
      <p className="portfolio-header__subtitle">
        Una muestra de los productos que elaboramos
      </p>
    </div>
  );
};

export default PortfolioHeader;
